export { default } from './PanelHeader'
